import { useState } from "react";
import { signIn } from "../lib/auth";

export function SignIn() {
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  const handleClick = async () => {
    setError(null);
    setLoading(true);
    try {
      await signIn();
    } catch (err) {
      setError(err instanceof Error ? err.message : "Sign-in failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="min-h-screen flex flex-col items-center justify-center px-4">
      <h1 className="text-3xl font-semibold mb-2">Learning Stories</h1>
      <p className="text-gray-600 mb-8">Monthly reports for Gordon Family Day Care</p>
      <button
        onClick={handleClick}
        disabled={loading}
        className="bg-[#ff6b35] text-white rounded-full px-6 py-3 font-medium disabled:opacity-50"
      >
        {loading ? "Signing in…" : "Sign in with Google"}
      </button>
      {error && <p className="mt-4 text-red-600 text-sm">{error}</p>}
    </main>
  );
}
